"use strict";
// copyright defined in eosjs/LICENSE.txt
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=eosjs-rpc-interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs/dist/eosjs-rpc-interfaces.js
// module id = r5l4
// module chunks = 6